import Member from './member'

export default class Player {
  members: Array<Member> = []

  constructor (name: string) {
    this.members = [new Member(name)]
  }
}
